export const colors = {
  navBtnBackground: "#FFD100",
  navActiveBtnBackground: "#2774AF",
  navButtonText: "#013B5A",
  navButtonHover: '#f9efb9',
};
  
export const fonts = {
};

export const mediaQueries = {
  mobile: "@media screen and (max-width: 700px)",
  notMobile: "@media screen and (min-width: 701px)",
  notTablet: "@media screen and (min-width: 901px)",
  tablet: "@media screen and (max-width: 900px)"
};
  
